var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InformationPage',{attrs:{"name":"Проекты ВКонтакте"}},[_vm._v(" Скоро напишу о VK Fresh Code и ещё одном проекте… ")])}
var staticRenderFns = []

export { render, staticRenderFns }